var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.69417 13.6206L0.40823 7.62034C0.23858 7.45851 0.142578 7.23415 0.142578 6.99978C0.142578 6.76542 0.23858 6.54105 0.40823 6.37923L6.69417 0.379013C7.03679 0.0531082 7.57924 0.0653944 7.90625 0.408014C8.23326 0.747312 8.22101 1.29197 7.87725 1.62013L3.13893 6.14261L15.2854 6.14261C15.7586 6.14261 16.1426 6.52655 16.1426 6.99978C16.1426 7.47302 15.7586 7.85696 15.2854 7.85696L3.13893 7.85696L7.87721 12.3794C8.22097 12.7065 8.23326 13.2511 7.90625 13.5915C7.57924 13.9342 7.03679 13.9465 6.69417 13.6206Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.60417df99db65106ea5d1803bf53739a.svg";
export { ForwardRef as ReactComponent };